/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CashFlowStatus = {
    Pending: 0,
    PartiallyPaidOnTime: 1,
    PartiallyPaidNotOnTime: 2,
    PaidOnTime: 3,
    PaidNotOnTime: 4,
    OverpaidOnTime: 5,
    OverpaidNotOnTime: 6,
    Overdue: 7,
    Cancelled: 8
} as const;

export type CashFlowStatus = typeof CashFlowStatus[keyof typeof CashFlowStatus];



